/**
 * Security utility to prevent developer tools access
 */
export const initSecurityMeasures = () => {
  // Detect devtools opening
  const devToolsDetector = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > 160;
    const heightThreshold = window.outerHeight - window.innerHeight > 160;

    if (widthThreshold || heightThreshold) {
      document.body.innerHTML = '<div style="text-align:center;padding:50px;"><h1>Developer Tools Detected</h1><p>For security reasons, this application cannot be used with developer tools open.</p><button onclick="location.reload()">Reload Page</button></div>';
    }
  };

  // Prevent right-click
  document.addEventListener("contextmenu", (e) => {
    e.preventDefault();
    return false;
  });

  // Prevent keyboard shortcuts
  document.addEventListener("keydown", (e) => {
    // Prevent F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+U , Ctrl+Shift+M ,Ctrl+A, Ctrl+V, Ctrl+C , Ctrl+X
    if (
      e.keyCode === 123 ||
      (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||
      (e.ctrlKey && e.shiftKey && e.keyCode === 74) ||
      (e.ctrlKey && e.shiftKey && e.keyCode === 67) ||
      (e.ctrlKey && e.keyCode === 85) ||
      (e.ctrlKey && e.shiftKey && e.keyCode === 77) ||
      (e.ctrlKey && e.keyCode === 65) ||
      (e.ctrlKey && e.keyCode === 86) ||
      (e.ctrlKey && e.keyCode === 67) ||
      (e.ctrlKey && e.keyCode === 88) ||
      e.keyCode === 9
    ) {
      e.preventDefault();
      return false;
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const inputs = document.querySelectorAll("input, textarea");

    inputs.forEach((input) => {
      input.addEventListener("paste", function (e) {
        e.preventDefault();
        alert("Pasting is disabled!");
      });
    });
  });

  // Check periodically for devtools
  // setInterval(devToolsDetector, 1000);

  // Console warning
  console.log("%cStop!", "color:red;font-size:50px;font-weight:bold");
  console.log("%cThis is a secure application. Using the console may compromise security.", "font-size:20px;");
};
